'use client'

import React, { useState } from 'react'
import Input from './Input';
import Button from './Button';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'

export default function Modal({
  open,
  title = 'Title',
  ctaButtonText = 'Yes',
  cancelButtonText = 'No',
  onConfirm,
  onCancel,
	children,
}) {

  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
    }
  }
    
  return (
    <Dialog open={open} onClose={onCancel} className="relative z-100">
			<DialogBackdrop
				transition
				className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in dark:bg-gray-900/50"
			/>

			<div className="fixed inset-0 z-100 w-screen overflow-y-auto">
				<div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
					<DialogPanel
						transition
						className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 dark:bg-gray-800 dark:outline dark:outline-1 dark:-outline-offset-1 dark:outline-white/10"
					>
						<div>
							<div className="">
								<DialogTitle className="text-base font-semibold text-gray-900 dark:text-white border-b border-gray-200 dark:border-gray-700 p-3 text-center">
									{title}
								</DialogTitle>
								<div className="p-4">
									{children}
								</div>
							</div>
						</div>
						<div className="p-4 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3 border-t border-gray-200 dark:border-gray-700">
							<Button
                type="button"
                variant="outline"
								className="inline-flex w-full justify-center"
                onClick={onCancel}>
                {cancelButtonText}
              </Button>
							<Button
                type="button"
                variant="primary"
								className="inline-flex w-full justify-center mt-3 sm:mt-0"
                onClick={handleConfirm}
								disabled={isLoading}>
                {isLoading ? 'Please wait...' : ctaButtonText}
              </Button>
						</div>
					</DialogPanel>
				</div>
			</div>
		</Dialog>
  )
}
